/* eslint-disable no-var */
/* eslint-disable prefer-const */
export const moneyFormat = (val: string) => {
  if (val === undefined || val === null || val === '') return '';
  // 캐쉬일 경우(양의 정수만 입력 가능)
  const pattern = /^[1-9]{1}[0-9]*$/g;
  if (!pattern.test(val)) {
    val = String(val).replace(/[^0-9]/g, '');
  }
  // 정수일 때 0으로 시작한다면 0 제거 (값 0은 제외)
  if (/^[0]+/.test(val) && val.length !== 1) {
    val = val.replace(/^[0]+/, '');
  }
  let parts = val.toString().replace(/,/g, '').split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

/** 사업자번호 변환 */
export const bizNumberFormat = (val: string) => {
  if (val === undefined || val === null || val === '') return '';
  // return val.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');

  val = val.replace(/[^0-9]/g, '');
  let tmp = '';
  if (val.length < 4) {
    return val;
  } else if (val.length < 6) {
    tmp += val.substr(0, 3);
    tmp += '-';
    tmp += val.substr(3);
    return tmp;
  } else if (val.length < 11) {
    tmp += val.substr(0, 3);
    tmp += '-';
    tmp += val.substr(3, 2);
    tmp += '-';
    tmp += val.substr(5);
    return tmp;
  }

  return val;
};

/** 빕언번호 변환 */
export const corparteNumberFormat = (val: string) => {
  if (val === undefined || val === null || val === '') return '';
  // return val.replace(/(\d{6})(\d{7})/, '$1-$2');

  val = val.replace(/[^0-9]/g, '');
  let tmp = '';
  if (val.length < 7) {
    return val;
  } else if (val.length < 15) {
    tmp += val.substr(0, 6);
    tmp += '-';
    tmp += val.substr(6);
    return tmp;
  }

  return val;
};

export const comma = (x: any) => {
  if (x == 0) {
    return '0';
  } else if (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return '';
  }
};

// 부호(-)를 보존하는 콤마 포맷 유틸 (음수 입력 허용 필드 전용)
export const commaWithSign = (x: any) => {
  if (x === '' || x === null || x === undefined) return '';
  const str = String(x);
  const isNeg = str.startsWith('-');
  const digits = str.replace(/[^0-9]/g, '');
  if (digits === '') return isNeg ? '-' : '';
  const trimmed = digits.replace(/^0+(?=\d)/, '');
  const formatted =
    (trimmed === '' ? '0' : trimmed).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return isNeg ? `-${formatted}` : formatted;
};

/** 금액 천만이상 단위 노출 */
export const unit = (p: any) => {
  let c = '',
    x = 1;
  if (Number(p ?? 0) == 0) {
    return '-';
  }
  if (!Number(p)) {
    return '';
  }
  if (Number(p) < 0) x = -1;

  p = p
    .toString()
    .replace(/\B(?=(\d{4})+(?!\d))/g, ',')
    .split(',');

  let addNumber = p[1] / 100 > 0 ? Math.round(p[1] / 1000) / 10 : 0;

  let checkZero = addNumber > 0 && addNumber < 1 ? '' : '.0';

  if (p.length == 5) {
    c +=
      comma(
        Number(p[0]) + (p[1] / 100 > 0 ? Math.round(p[1] / 1000) / 10 : 0) * x
      ) +
      checkZero +
      '경';
  } else if (p.length == 4) {
    c +=
      comma(
        Number(p[0]) + (p[1] / 100 > 0 ? Math.round(p[1] / 1000) / 10 : 0) * x
      ) +
      checkZero +
      '조';
  } else if (p.length == 3) {
    c +=
      comma(
        Number(p[0]) + (p[1] / 100 > 0 ? Math.round(p[1] / 1000) / 10 : 0) * x
      ) +
      checkZero +
      '억';
  } else if (p.length == 2) {
    c +=
      comma(
        Number(p[0]) + (p[1] / 100 > 0 ? Math.round(p[1] / 1000) / 10 : 0) * x
      ) +
      checkZero +
      '만';
  } else if (p.length == 1) {
    c +=
      comma(
        Number(p[0]) + (p[1] / 100 > 0 ? Math.round(p[1] / 1000) / 10 : 0) * x
      ) + '';
  }

  return c;
};

/** 포트폴리오 성장정보에서 사용하는 빈값 치환 */
export const blankToHyphen = (v: any) => {
  if (v === '' && v.length === 0) {
    return '-';
  } else {
    return v;
  }
};

/** 핸드폰/유선전화 통합 하이픈(-) 붙이기 */
export const phoneFormat = (v: any) => {
  if (v === undefined || v === null || v === '') return v;
  v = String(v).replace(/-/g, '');
  return v.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
};

/** 파일 다운로드 */
export const downloadURI = async (uri: any) => {
  try {
    var link = document.createElement('a');
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err: any) {
    return Promise.reject(err);
  }
};

/** 값이 null이나 undefined인지 여부 */
export function isNil<T>(val: T | undefined | null): val is null | undefined {
  return val == null;
}

/** 값이 null이나 undeifined가 아닌지 여부 */
export function isNotNil<T>(val: T | undefined | null): val is T {
  return val != null;
}
